import React, { useMemo } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import { toSplitRows } from "../redzoneRows";
import "./RedzoneTeamSplitsDisplay.css";

const TEAM_SPLITS = graphql`
  query RedzoneTeamSplitsDisplayQuery($teamIds: [ID], $seasonID: ID) {
    nflRedzoneTeamSplits(teamIds: $teamIds, seasonId: $seasonID) {
      id

      season {
        year
      }

      team {
        abbreviation
      }

      passes
      rushes
      totalPlays
    }
  }
`;

export default function RedzoneTeamSplitsDisplay({ variables, fetchKey, emptyState }) {
  const data = useLazyLoadQuery(
    TEAM_SPLITS,
    { teamIds: variables.teamIds, seasonID: variables.seasonID },
    { fetchKey, fetchPolicy: fetchKey > 0 ? "network-only" : "store-or-network" }
  );

  if (!data.nflRedzoneTeamSplits) {
    throw new Error("nflRedzoneTeamSplits returned null");
  }

  const rows = useMemo(
    () => toSplitRows(data.nflRedzoneTeamSplits),
    [data.nflRedzoneTeamSplits]
  );

  if (rows.length === 0) {
    return emptyState;
  }

  return (
    <div className="nfl-rz-splits">
      <p className="nfl-rz-splits-legend">
        <span className="nfl-rz-key nfl-rz-key-pass" aria-hidden="true" />
        Pass
        <span className="nfl-rz-key nfl-rz-key-rush" aria-hidden="true" />
        Rush
      </p>
      <ul className="nfl-rz-split-list">
        {rows.map((row) => (
          <li key={row.id} className="nfl-rz-split">
            <span className="nfl-rz-split-team nfl-display">{row.abbreviation}</span>
            <span className="nfl-rz-split-bar">
              <span
                className="nfl-rz-split-pass"
                style={{ width: `${row.passPct}%` }}
              >
                <span className="nfl-rz-visually-hidden">Pass </span>
                {row.passPct}%
              </span>
              <span
                className="nfl-rz-split-rush"
                style={{ width: `${row.rushPct}%` }}
              >
                <span className="nfl-rz-visually-hidden">Rush </span>
                {row.rushPct}%
              </span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
